export class ParticipantAddress {
  city: string;
  stateCode: string;
  streetAddress1: string;
  streetAddress2: string | null;
  zipCode: string;
  zip4: string | null;
}
